export const TEXT = {
    NOT_AVAILABLE: 'Not Available'
};